/**
 * @file dataControlsView.ts
 * @brief What a user may share or export under their company's data controls
 *        (ADR-051, DES 21-10-2026), from `/auth/me` `dataControls`.
 *
 * @details
 * Unknown (loading, personal account, older server, the server's off
 * switch) reads as allowed: the server is the one that refuses. A meeting
 * owned by another company carries its own `exports_disabled`.
 * Pure, so `node --test` can load it.
 *
 * @author DES
 * @date 21-10-2026
 */

export const DEFAULT_SHARE_LINE = "Your company only allows sharing inside the company.";
export const DEFAULT_EXPORT_LINE = "Your company admin has turned off exports.";

export type DataControlsInput = {
  canShareOutside?: boolean;
  canExport?: boolean;
  shareLine?: string | null;
  exportLine?: string | null;
} | null;

export function dataControlsView(dc: DataControlsInput) {
  const shareBlocked = dc?.canShareOutside === false;
  const exportBlocked = dc?.canExport === false;
  return {
    canShareOutside: !shareBlocked,
    canExport: !exportBlocked,
    shareLine: shareBlocked ? dc?.shareLine || DEFAULT_SHARE_LINE : null,
    exportLine: exportBlocked ? dc?.exportLine || DEFAULT_EXPORT_LINE : null,
  };
}

export function meetingExportView(dc: DataControlsInput, meeting: object | null | undefined) {
  const v = dataControlsView(dc);
  const blocked =
    !v.canExport || (meeting as { exports_disabled?: unknown } | null)?.exports_disabled === true;
  return { canExport: !blocked, exportLine: blocked ? v.exportLine || DEFAULT_EXPORT_LINE : null };
}
